import axios from 'axios';

const createAxiosInstance = () =>
  axios.create({
    paramsSerializer: {
      // Escape the following characters just to be safe
      encode: (val) => {
        return val
          .toString()
          .replace(/%/gi, '%25')
          .replace(/\[/gi, '%5B')
          .replace(/\]/gi, '%5D')
          .replace(/\$/gi, '%24');
      },
    },
  });

const httpClient = createAxiosInstance();

// adds access tokens in all api requests
// this interceptor is only added when the auth0 instance is ready and exports the getAccessTokenSilently method
export const addAccessTokenInterceptor = (getAccessTokenSilently) => {
  httpClient.interceptors.request.use(async (config) => {
    try {
      const newConfig = config;
      const { audience } = window?.globalConfig?.auth0 || {};

      if (!audience) {
        // eslint-disable-next-line no-console
        console.warn('[axios] window.globalConfig.auth0 not available yet', window?.globalConfig);
        return newConfig;
      }

      const token = await getAccessTokenSilently({
        authorizationParams: { audience },
      });

      if (token) {
        newConfig.headers.Authorization = `Bearer ${token}`;
      }
      return newConfig;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('[axios] Failed to add auth token:', err);
      return config;
    }
  });
};

export const axiosWithoutAuth = createAxiosInstance();

export default httpClient;
